<template>
  <v-container fluid>
    <v-row justify="center">
      <!-- ////////////////////////////////////VER EMPRESA/////////////////////////////////////////////////////////////// -->
      <v-col cols="12" class="text-center">
        <v-data-table
          :items="items_empresas"
          :headers="headers_empresas"
          dense
          disable-pagination
          :search="search"
          :loading="loading"
        >
          <template v-slot:top>
            <v-toolbar elevation="0">
              <v-btn color="green" dark @click="BusquedaEmpresa()"
                >Recargar</v-btn
              >
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                label="Buscar"
                outlined
                dense
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="NuevaEmpresa()">Nuevo</v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.username`]="{ item }">
            <span>{{ recortarCadena(item.username) }}</span>
          </template>
          <template v-slot:[`item.pwd`]="{ item }">
            <span>{{ recortarCadena(item.pwd) }}</span>
          </template>
          <template v-slot:[`item.token`]="{ item }">
            <span>{{ recortarCadena(item.token) }}</span>
          </template>
          <template v-slot:[`item.bloc`]="{ item }">
            <span v-if="item.bloc">
              <v-chip color="green" dark small>Activo</v-chip>
            </span>
            <span v-else>
              <v-chip color="grey" dark small>No activo</v-chip>
            </span>
          </template>
          <template v-slot:[`item.opciones`]="{ item }">
            <v-icon @click="editarEmpresa(item)"
              >fa-solid fa-pen-to-square</v-icon
            >
          </template>
        </v-data-table>
      </v-col>
      <!-- ////////////////////////////////////NUEVO, EDITAR EMPRESA/////////////////////////////////////////////////// -->
      <v-dialog v-model="dialog_empresa" width="800" persistent scrollable>
        <v-card>
          <v-card-title>
            EMPRESA
            <v-spacer></v-spacer>
            <v-img
              v-if="false"
              :src="'data:image/png;base64,' + this.logo"
              max-width="100"
              max-height="100"
              contain
            ></v-img>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="auto">
                <v-switch
                  v-model="estado"
                  inset
                  :label="`Estado: ${estado ? 'Activo' : 'Inactivo'}`"
                  hide-details
                  class="pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="auto" class="pl-5">
                <v-switch
                  v-model="ambiente"
                  inset
                  :label="`Ambiente: ${ambiente ? 'Produccion' : 'Pruebas'}`"
                  hide-details
                  class="pt-0"
                ></v-switch>
              </v-col>
              <v-col cols="auto" class="pl-5">
                <v-switch
                  v-model="mora"
                  inset
                  :label="`Mora: ${mora ? 'SI' : 'NO'}`"
                  hide-details
                  class="pt-0"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <v-text-field
                  id="result"
                  v-model="codigo"
                  label="Código"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="auto" align-self="center">
                <v-btn
                  color="primary"
                  @click="listarLogo()"
                  v-if="flag_edit_new == 2"
                  >LOGO</v-btn
                >
                <v-file-input
                  v-if="false"
                  label="Logo"
                  outlined
                  dense
                  id="myFileInput"
                  hide-details
                ></v-file-input>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="nombre"
                  label="Nombre"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="direccion"
                  label="Dirección"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="registro_fiscal"
                  label="Registro fiscal"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="telefono"
                  label="Teléfono"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="nit"
                  label="NIT"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="departamento"
                  :items="items_departamentos"
                  item-text="nombre"
                  item-value="cod_MH"
                  label="Departamento"
                  outlined
                  dense
                  hide-details
                  @input="listarMunicipios(departamento)"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="municipio"
                  :items="items_municipios"
                  item-text="nombre"
                  item-value="cod_MH"
                  label="Distrito"
                  outlined
                  dense
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  v-model="municipio2"
                  :items="items_municipios2"
                  item-text="nom_muni2"
                  item-value="cod_muni_MH"
                  label="Municipio"
                  outlined
                  dense
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="giro"
                  label="Giro"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="correo"
                  label="Correo"
                  outlined
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="recinto_fiscal"
                  :items="items_recinto_fiscal"
                  label="Recinto fiscal"
                  item-text="nombre"
                  item-value="cod_MH"
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection="data">
                    {{ data.item.cod_MH }} {{ data.item.nombre }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.cod_MH }} {{ data.item.nombre }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="actividad_economica"
                  :items="items_acti_economica"
                  item-text="nombre"
                  item-value="cod_MH"
                  label="Actividad Económica"
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection="data">
                    {{ data.item.cod_MH.trim() }} {{ data.item.nombre }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.cod_MH.trim() }} {{ data.item.nombre }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="regimen_exportacion"
                  :items="items_regimen_exportacion"
                  item-text="nombre"
                  item-value="cod_MH"
                  label="Régimen de exportación"
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection="data">
                    {{ data.item.cod_MH }} {{ data.item.nombre }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.cod_MH }} {{ data.item.nombre }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="usuario"
                  label="Usuario"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="contraseña"
                  label="Contraseña"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="ruta_archivo"
                  label="Ruta archivo"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="clave_privada"
                  label="Clave privada"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="token"
                  label="Token"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="expire"
                  label="Expire token"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="nombre_db"
                  label="Base de datos"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="rubro"
                  :items="items_rubro"
                  item-text="rubro"
                  item-value="id_rubro"
                  label="Sector Empresa"
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection="data">
                    {{ data.item.codigo }} {{ data.item.rubro }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.codigo }} {{ data.item.rubro }}
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="auto" align-self="center">
                <v-checkbox
                  v-model="blocs"
                  label="Activar blocs"
                  dense
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3" v-if="blocs">
                <v-text-field
                  v-model="valor_restante"
                  label="Restantes"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  @input="validarNumero()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" v-if="blocs">
                <v-text-field
                  v-model="valor_sumado"
                  label="Sumados"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  @input="validarNumero()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="CrearEmpresa()"
              v-if="flag_edit_new == 1"
              >Guardar</v-btn
            >
            <v-btn
              color="primary"
              @click="actualizarEmpresa()"
              v-if="flag_edit_new == 2"
              >Actualizar</v-btn
            >
            <v-btn
              color="red"
              dark
              v-if="flag_edit_new == 2"
              @click="eliminarEmpresa()"
              >Eliminar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn text @click="cerrarDialogEmpresa()">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialog_logo" width="800" persistent>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title> Logo </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="tiene_mas_logos"
            label="Tiene más logos"
            dense
            hide-details
          ></v-checkbox>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12">
              <v-file-input
                v-model="logo_input"
                label="Archivo"
                outlined
                dense
                hide-details
                color="light-blue"
                prepend-icon="fa-solid fa-image"
                id="myFileInput"
                @change="onFileChange"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="light-blue" dark label small>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="auto">
              <v-img
                :src="logo"
                max-width="300"
                max-height="300"
                contain
              ></v-img>
            </v-col>
            <v-col cols="12" v-if="tiene_mas_logos">
              <v-data-table :headers="headers_logos" :items="items_logos" dense>
                <template v-slot:top>
                  <v-row justify="center">
                    <v-col cols="5">
                      <v-text-field
                        v-model="punto_venta"
                        label="Punto de venta"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <v-file-input
                        v-model="logo_multiple_input"
                        label="Logo"
                        outlined
                        dense
                        hide-details
                        prepend-icon="fa-solid fa-image"
                        id="myFileInputMultiple"
                        @change="onFileChangeMultiple"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn icon outlined>
                        <v-icon color="green" @click="agregarLogo()"
                          >fa-solid fa-check</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.logo`]="{ item }">
                  <v-img
                    :src="'data:image/png;base64,' + item.logo"
                    width="200"
                    height="200"
                    contain
                    class="mx-auto"
                    v-if="item.id_logos_empresas"
                  ></v-img>
                  <span v-else> {{ recortarBytes(item.logo) }}</span>
                </template>
                <template v-slot:[`item.action_eliminar`]="{ item }">
                  <v-btn
                    outlined
                    color="red"
                    @click="confirmarEliminarLogoMultiple(item)"
                  >
                    <v-icon>fa-solid fa-trash-can</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="guardarLogo()"
            v-if="flag_edit_new == 2"
            >Guardar</v-btn
          >
          <v-btn
            color="red"
            dark
            @click="dialog_eliminar_logo = true"
            v-if="flag_edit_new == 2"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogLogo()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_logo_multiple" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de eliminar el logo?</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarLogoMultiple()"
            >Si, eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text>Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_empresa" width="500" persistent>
      <v-card>
        <v-toolbar elevation="0" dense>
          <v-toolbar-title
            >¿Esta seguro de eliminar la empresa?</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="pb-0">
          <p class="title font-weight-bold">
            {{ nombre }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarEmpresa()"
            >Si, Eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog_eliminar_empresa = !dialog_eliminar_empresa"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_logo" width="500" persistent>
      <v-card>
        <v-toolbar elevation="0" dense>
          <v-toolbar-title>¿Esta seguro de eliminar el logo?</v-toolbar-title>
        </v-toolbar>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarLogo()">Si, Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog_eliminar_empresa = !dialog_eliminar_empresa"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="-1"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ text_snackbar }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>fa-regular fa-circle-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-overlay v-model="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import axios from "axios";
import settings from "../../settings/settings";

export default {
  data: () => ({
    dialog_logo: false,
    logo_input: [],
    dialog_eliminar_logo: false,
    search: "",
    snackbar: false,
    text_snackbar: "Mensaje",
    icon_snackbar: "fa-solid fa-circle-info",
    overlay: false,
    //////////EMPRESA///////////////
    items_empresas: [],
    headers_empresas: [
      { text: "Código", value: "cod_empresa", sortable: false },
      { text: "Nombre", value: "nombre_empresa", sortable: false },
      { text: "Usuario", value: "username", sortable: false },
      { text: "Contraseña", value: "pwd", sortable: false },
      { text: "Token", value: "token", sortable: false },
      { text: "Blocs", value: "bloc", sortable: false, align: "center" },
      {
        text: "Blocs restantes",
        value: "bloc_restante",
        sortable: false,
        align: "center",
      },
      {
        text: "Blocs sumados",
        value: "bloc_sumados",
        sortable: false,
        align: "center",
      },
      { text: "Editar", value: "opciones", align: "center", sortable: false },
    ],
    direccion: "",
    registro_fiscal: "",
    telefono: "",
    nit: "",
    giro: "",
    correo: "",
    items_acti_economica: [],
    actividad_economica: "",
    items_regimen_exportacion: [],
    regimen_exportacion: "",
    recinto_fiscal: "",
    items_recinto_fiscal: [],
    items_departamentos: [],
    items_municipios: [],
    items_municipios2: [],
    departamento: "",
    municipio: "",
    municipio2: "",
    dialog_empresa: false,
    id_empresa: 0,
    codigo: "",
    nombre: "",
    usuario: "",
    contraseña: "",
    ruta_archivo: "",
    clave_privada: "",
    token: "",
    expire: "",
    flag_edit_new: 1,
    nombre_logo: "",
    logo: null,
    fileByteArray: null,
    nombre_db: "",
    loading: false,
    dialog_eliminar_empresa: false,
    ambiente: false,
    estado: true,
    //Nuevo
    items_rubro: [],
    rubro: "",
    item: [],
    valor_restante: 0,
    valor_sumado: 0,
    blocs: false,
    mora: false,
    tiene_mas_logos: false,
    headers_logos: [
      { text: "Punto de venta", value: "cod_punto_venta", align: "center" },
      { text: "Logo", value: "logo", align: "center" },
      { text: "Eliminar", value: "action_eliminar", align: "center" }
    ],
    items_logos: [],
    punto_venta: "",
    logo_multiple_input: [],
    logo_multiple: null,
    dialog_eliminar_logo_multiple: false,
    temp_logo_eliminar: null,
    id_logos_empresas: 0
  }),
  created() {
    this.BusquedaEmpresa();
    this.listarDepartamentos();
    this.listarRegimenExportacion();
    this.listarRecintoFiscales();
    this.listarActividadEconomica();
    this.listarRubro();
  },
  methods: {
    confirmarEliminarLogoMultiple(item) {
      this.temp_logo_eliminar = item;
      this.dialog_eliminar_logo_multiple = true;
    },
    eliminarLogoMultiple() {
      axios
        .delete(
          "api/Logos/Eliminar/" + this.temp_logo_eliminar.id_logos_empresas
        )
        .then((response) => {
          this.temp_logo_eliminar = null;
          this.dialog_eliminar_logo_multiple = false;
          this.listarLogo();
        });
    },
    agregarLogo() {
      if (this.punto_venta == "" || this.logo_multiple.length == 0) {
        return;
      }

      this.items_logos.push({
        cod_punto_venta: this.punto_venta,
        logo: this.logo_multiple,
      });

      this.punto_venta = "";
      this.logo_multiple_input = [];
      this.logo_multiple = null;
    },
    async onFileChangeMultiple(file) {
      if (!file) {
        return;
      }

      let myFile = document.getElementById("myFileInputMultiple").files[0];

      if (myFile == undefined) {
        return null;
      }
      let byteArray = await this.fileToByteArray(myFile);

      this.logo_multiple = byteArray;
    },
    onFileChange(file) {
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    listarLogo() {
      axios
        .get("api/DetallesEmpresas/ListarLogo/" + this.id_empresa)
        .then((response) => {
          this.dialog_logo = true;
          if (response.data != "") {
            this.logo = "data:image/png;base64," + response.data;
          }
        });

      axios.get("api/Logos/Listar/" + this.id_empresa).then((response) => {
        this.items_logos = response.data;
      });
    },
    async guardarLogo() {
      axios
        .put("api/DetallesEmpresas/ActualizarLogo", {
          id_empresa: this.id_empresa,
          logo: await this.convertImage(),
        })
        .then(() => {
          this.text_snackbar = "Logo guardado";
          this.snackbar = true;
          this.guardarMultipleLogo();
          this.cerrarDialogLogo();
        })
        .catch(() => {
          this.text_snackbar = "Error al guardar el logo";
          this.snackbar = true;
        });
    },
    guardarMultipleLogo() {
      for (var i = 0; i < this.items_logos.length; i++) {
        axios
          .post("api/Logos/Crear", {
            id_logos_empresas:
              this.items_logos[i].id_logos_empresas == undefined
                ? 0
                : this.items_logos[i].id_logos_empresas,
            id_empresa: this.id_empresa,
            cod_punto_venta: this.items_logos[i].cod_punto_venta,
            logo: this.items_logos[i].logo,
          })
          .then(() => {
            this.listarLogo();
          });
      }
    },
    eliminarLogo() {
      axios
        .put("api/DetallesEmpresas/EliminarLogo/" + this.id_empresa)
        .then(() => {
          this.text_snackbar = "Logo eliminado";
          this.snackbar = true;
          this.dialog_eliminar_logo = false;
          this.cerrarDialogLogo();
        })
        .catch(() => {
          this.text_snackbar = "No se elimino el logo";
          this.snackbar = true;
        });
    },
    cerrarDialogLogo() {
      this.logo_input = [];
      this.logo = null;
      this.dialog_logo = false;
    },
    validarNumero() {
      if (this.valor_sumado < 0) {
        this.valor_sumado = 0;
      }

      if (this.valor_restante < 0) {
        this.valor_restante = 0;
      }
    },
    async listarDepartamentos() {
      this.items_departamentos = await (
        await settings.metodos.Departamentos()
      ).data;
    },
    async listarMunicipios(item) {
      if (!item) {
        return;
      }
      var departamento = await (
        await settings.metodos.DepartamentoCodMH(item)
      ).data;
      this.items_municipios = await (
        await settings.metodos.Municipios(departamento.cod_depa)
      ).data;
      this.items_municipios2 = await (
        await settings.metodos.Municipios2(departamento.cod_depa)
      ).data;
    },
    listarRegimenExportacion() {
      axios.get("api/RegimenExportacion/Listar").then((response) => {
        this.items_regimen_exportacion = response.data;
      });
    },
    listarRecintoFiscales() {
      axios.get("api/RecintoFiscal/Listar").then((response) => {
        this.items_recinto_fiscal = response.data;
      });
    },
    listarActividadEconomica() {
      axios.get("api/ActividadEconomicas/Listar").then((response) => {
        this.items_acti_economica = response.data;
      });
    },
    listarRubro() {
      axios
        .get("api/Rubro/Listar")
        .then((response) => {
          if (Array.isArray(response.data)) {
            this.items_rubro = response.data;
          } else {
            console.error("La API no devolvió un array:", response.data);
            this.items_rubro = []; // Siempre sea un array
          }
        })
        .catch((error) => {
          console.error("Error al obtener rubros:", error);
          this.items_rubro = [];
        });
    },
    BusquedaEmpresa() {
      this.loading = true;
      axios
        .get("api/UsuariosXEmpresas/Listar")
        .then((response) => {
          //console.log(response.data);
          this.items_empresas = response.data;
          this.items_empresas.sort((a, b) => {
            return (b.bloc === true) - (a.bloc === true);
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    CrearEmpresa() {
      if (!this.codigo) {
        this.text_snackbar = "Campos Código no puede quedar vacio";
        this.snackbar = true;
        return;
      }

      this.overlay = true;
      axios
        .put("api/DetallesEmpresas/Crear", {
          cod_empresa: this.codigo,
          nombre_empresa: this.nombre,
          direccion: this.direccion,
          registro_fiscal: this.registro_fiscal,
          telefono: this.telefono,
          nit: this.nit,
          departamento: this.departamento,
          municipio: this.municipio,
          municipio2: this.municipio2,
          giro: this.giro,
          correo: this.correo,
          recinto_fiscal: this.recinto_fiscal,
          codigo_actividad: this.actividad_economica,
          regimen_exportacion: this.regimen_exportacion,
          username: this.usuario,
          pwd: this.contraseña,
          ruta_archivo: this.ruta_archivo,
          clave_privada: this.clave_privada,
          nombre_db: this.nombre_db,
          rubro: this.rubro,
          bloc: this.blocs,
          bloc_restante: this.valor_restante,
          bloc_sumados: this.valor_sumado,
          ambiente: this.ambiente ? "01" : "00",
          estado: this.estado,
          mora: this.mora,
        })
        .then((response) => {
          this.cerrarDialogEmpresa();
          this.BusquedaEmpresa();
          this.text_snackbar = response.data;
          this.snackbar = true;
          this.overlay = false;
          this.alerta("fa-solid fa-check", response.data);
        })
        .catch((error) => {
          this.snackbar = true;
          this.overlay = false;
          this.alerta("fa-solid fa-xmark", "No se pudo crear el registro");
        });
    },
    async actualizarEmpresa() {
      this.overlay = true;
      axios
        .put("api/DetallesEmpresas/Actualizar", {
          id_empresa: this.id_empresa,
          cod_empresa: this.codigo,
          nombre_empresa: this.nombre,
          direccion: this.direccion,
          registro_fiscal: this.registro_fiscal,
          telefono: this.telefono,
          nit: this.nit,
          departamento: this.departamento,
          municipio: this.municipio,
          municipio2: this.municipio2,
          giro: this.giro,
          correo: this.correo,
          recinto_fiscal: this.recinto_fiscal,
          codigo_actividad: this.actividad_economica,
          regimen_exportacion: this.regimen_exportacion,
          username: this.usuario,
          pwd: this.contraseña,
          ruta_archivo: this.ruta_archivo,
          clave_privada: this.clave_privada,
          token: this.token,
          expire_token: this.expire,
          nombre_db: this.nombre_db,
          rubro: this.rubro,
          bloc: this.blocs,
          bloc_restante: this.valor_restante,
          bloc_sumados: this.valor_sumado,
          ambiente: this.ambiente ? "01" : "00",
          estado: this.estado,
          mora: this.mora,
          tiene_mas_logos: this.tiene_mas_logos
        })
        .then(() => {
          this.dialog_empresa = false;
          this.overlay = false;
          this.alerta("fa-solid fa-check", "Actualizado con exito");
          this.cerrarDialogEmpresa();
          this.BusquedaEmpresa();
          this.escucharServer();
        })
        .catch(() => {
          this.overlay = false;
          this.alerta("fa-solid fa-xmark", "No se pudo actualizar el registro");
        });
    },
    NuevaEmpresa() {
      this.flag_edit_new = 1;
      this.dialog_empresa = true;
    },
    editarEmpresa(item) {
      //console.log(item);
      this.flag_edit_new = 2;
      this.id_empresa = item.id_empresa;
      this.codigo = item.cod_empresa;
      this.nombre = item.nombre_empresa;
      this.direccion = item.direccion;
      this.registro_fiscal = item.registro_fiscal;
      this.telefono = item.telefono;
      this.nit = item.nit;
      this.departamento = item.departamento;
      this.municipio = item.municipio;
      this.municipio2 = item.municipio2;
      this.giro = item.giro;
      this.correo = item.correo;
      this.recinto_fiscal = item.recinto_fiscal;
      this.actividad_economica = item.codigo_actividad;
      this.regimen_exportacion = item.regimen_exportacion;
      this.usuario = item.username;
      this.contraseña = item.pwd;
      this.ruta_archivo = item.ruta_archivo;
      this.clave_privada = item.clave_privada;
      this.token = item.token;
      this.expire = item.expire_token;
      this.logo = item.logo;
      this.nombre_logo = item.nombre_logo;
      this.nombre_db = item.nombre_db;
      this.blocs = item.bloc;
      this.valor_restante = item.bloc_restante;
      this.valor_sumado = item.bloc_sumados;
      this.rubro = item.rubro;
      this.ambiente = item.ambiente == "01" ? true : false;
      this.estado = item.estado;
      this.mora = item.mora;
      this.tiene_mas_logos = item.tiene_mas_logos;

      this.listarMunicipios(this.departamento);

      this.dialog_empresa = true;
    },
    cerrarDialogEmpresa() {
      this.dialog_empresa = false;
      this.limpiarVarEmpresas();
    },
    limpiarVarEmpresas() {
      this.id_empresa = 0;
      this.codigo = "";
      this.nombre = "";
      this.direccion = "";
      this.registro_fiscal = "";
      this.telefono = "";
      this.nit = "";
      this.departamento = "";
      this.municipio = "";
      this.municipio2 = "";
      this.giro = "";
      this.correo = "";
      this.recinto_fiscal = "";
      this.actividad_economica = "";
      this.regimen_exportacion = "";
      this.usuario = "";
      this.contraseña = "";
      this.ruta_archivo = "";
      this.clave_privada = "";
      this.token = "";
      this.expire = "";
      this.logo = "";
      this.nombre_logo = "";
      this.nombre_db = "";
      this.rubro = "";
      this.blocs = false;
      this.valor_restante = 0;
      this.valor_sumado = 0;
      this.ambiente = false;
      this.estado = true;
      this.mora = false;
      this.tiene_mas_logos = false;
    },
    alerta(icon, mensaje) {
      this.icon_snackbar = icon;
      this.text_snackbar = mensaje;
      this.snackbar = true;
    },
    async convertImage() {
      if (document.getElementById("myFileInput").files[0] == undefined) {
        return null;
      }
      let myFile = document.getElementById("myFileInput").files[0];

      this.nombre_logo = myFile.name;
      if (myFile == undefined) {
        return null;
      }
      let byteArray = await this.fileToByteArray(myFile);
      return byteArray;
    },
    fileToByteArray(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          let fileByteArray = [];
          reader.readAsArrayBuffer(file);
          reader.onloadend = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (var i = 0; i < array.length; i++) {
                fileByteArray.push(array[i]);
              }
            }
            resolve(fileByteArray);
          };
        } catch (e) {
          reject(e);
        }
      });
    },
    recortarCadena(item) {
      return item != null ? item.substring(0, 10) + "..." : "...";
    },
    recortarBytes(item) {
      return item.slice(0, 20);
    },
    eliminarEmpresa() {
      this.dialog_eliminar_empresa = true;
    },
    confirmarEliminarEmpresa() {
      axios
        .delete("api/DetallesEmpresas/Eliminar/" + this.id_empresa)
        .then((response) => {
          if (response.data == 400) {
            this.text_snackbar =
              "No se puede eliminar la empresa, tiene movimientos relacionados";
            this.snackbar = true;
            return;
          }
          this.text_snackbar = "Empresa eliminada con exito";
          this.snackbar = true;
          this.BusquedaEmpresa();
          this.dialog_eliminar_empresa = false;
          this.dialog_empresa = false;
        })
        .catch(() => {
          this.text_snackbar = "No se pudo eliminar la empresa";
          this.snackbar = true;
        });
    },
    escucharServer() {
      axios.get("api/Usuarios/ListenServer");
    },
  },
};
</script>